/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Cloud_Url_LabelInputs */

const en_new_project_cloud_url_label = /** @type {(inputs: New_Project_Cloud_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud Storage URL`)
};

const fr_new_project_cloud_url_label = /** @type {(inputs: New_Project_Cloud_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL du stockage cloud`)
};

const de_new_project_cloud_url_label = /** @type {(inputs: New_Project_Cloud_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud-Speicher-URL`)
};

const it_new_project_cloud_url_label = /** @type {(inputs: New_Project_Cloud_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL di archiviazione cloud`)
};

const ru_new_project_cloud_url_label = /** @type {(inputs: New_Project_Cloud_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL облачного хранилища`)
};

const es_new_project_cloud_url_label = /** @type {(inputs: New_Project_Cloud_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de almacenamiento en la nube`)
};

const zh_cn2_new_project_cloud_url_label = /** @type {(inputs: New_Project_Cloud_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`云存储 URL`)
};

const ja_new_project_cloud_url_label = /** @type {(inputs: New_Project_Cloud_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クラウドストレージURL`)
};

const hi_new_project_cloud_url_label = /** @type {(inputs: New_Project_Cloud_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लाउड स्टोरेज यूआरएल`)
};

const pt_pt2_new_project_cloud_url_label = /** @type {(inputs: New_Project_Cloud_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de armazenamento em nuvem`)
};

/**
* | output |
* | --- |
* | "Cloud Storage URL" |
*
* @param {New_Project_Cloud_Url_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_cloud_url_label = /** @type {((inputs?: New_Project_Cloud_Url_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Cloud_Url_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_cloud_url_label(inputs)
	if (locale === "de") return de_new_project_cloud_url_label(inputs)
	if (locale === "it") return it_new_project_cloud_url_label(inputs)
	if (locale === "ru") return ru_new_project_cloud_url_label(inputs)
	if (locale === "es") return es_new_project_cloud_url_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_cloud_url_label(inputs)
	if (locale === "ja") return ja_new_project_cloud_url_label(inputs)
	if (locale === "hi") return hi_new_project_cloud_url_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_cloud_url_label(inputs)
	return en_new_project_cloud_url_label(inputs)
});